import * as React from 'react';
import {IControlSchema, createControl, ControlErrorListItem, IControlError} from "../../Controls";
import {Component, getRandomKey, goToAnchor} from "../../Utils";
import {IDispatcher} from "../extensions/Dispatcher";
import {ApiClient} from "../../../services/ApiClient";
import { findIndex, isNull, isUndefined } from 'lodash';
import { Panel, Button, Alert } from 'react-bootstrap';
import {Dictionary} from "../../../types/Dictionary";

interface Props{
    metadata: Array<IControlSchema>,
    dispatcher: IDispatcher,
    disabled: boolean,
    api: ApiClient,
    errors: Dictionary<IControlError | undefined>,
    visited: Dictionary<boolean>,
    allVisited: boolean,
    values: any,
    rows: Array<{ key: number, controls: Array<{ id: string, name: string }>}>,
    onAdd(row: { key: number, controls: Array<{ id: string, name: string }>}),
    onRemove(key: number, isError: boolean),
    onCopy()
}


class PanelCloneRow extends React.Component<{ id: number, 
                                            controls: Array<{ id: string, name: string }>,
                                            metadata:Array<IControlSchema>
                                            onRemove?: any,
                                            isError: boolean,
                                            api: ApiClient,
                                            errors: Dictionary<IControlError | undefined>,
                                            values: any,
                                            visited: Dictionary<boolean>,
                                            allVisited: boolean,
                                            dispatcher: IDispatcher
                                            }>{

    constructor(){
        super();
        this._handleClickRemove = this._handleClickRemove.bind(this);
    }

    _handleClickRemove(){
        let self = this;

        this.props.api.isRemovePanelBlock(this.props.id.toString(), {
            success (data){
                if(data.isRemove === "0"){
                    self.props.onRemove(self.props.id, true);
                }
                else
                    self.props.onRemove(self.props.id, false);
            }
        } )
    }

    getControlSchema(controlId: string){
        const { metadata } = this.props;

        const idx = findIndex(metadata, (o: IControlSchema) => o.id === controlId);
       
        return idx > -1 ? {...metadata[idx]} : null;
    }

    
    componentDidMount() {
    }

    render(){
        const elemets : Array<React.ReactElement<any>> = [];
        const { controls, api, dispatcher, values, errors, visited, allVisited } = this.props;
        
        for(let control of controls){
            let schema = this.getControlSchema(control.name);
            if(schema !== null){
                let value = null;
                const idx = findIndex(values, (o: any) => o.controlid === control.id);
                if(idx > -1){
                    value = values[idx].value;
                }
                schema = {...schema, value, id: control.id} as any;

                let element = null;
                if(schema.type.toLocaleUpperCase() === 'NUMBER'){
                    const d: any = Object.create(dispatcher);
                    d.onBlur = (id, value, s, error) => dispatcher.onAddValueRefresh(id, value, error);
                    element = createControl(schema, api, d, errors, values, visited, allVisited);
                } else {
                    element = createControl(schema, api, dispatcher, errors, values, visited, allVisited);
                }
                
                elemets.push(React.cloneElement(element, {key: `PanelCloneRow.${this.props.id}.${control.id}`}))
            }
        }

        return (
            <Panel>
                <Panel.Body>
                    {elemets}
                </Panel.Body>
                <Panel.Footer>
                    <Button bsStyle="danger" onClick={this._handleClickRemove}>Удалить</Button>
                    {
                        this.props.isError && (<Alert bsStyle="danger">Перед удалением очистите ВСЕ поля блока</Alert>)
                           
                    }
                </Panel.Footer>
            </Panel>
        )
    }
}

class PanelClone extends Component<Props, {}>{
    constructor(){
        super();
       
        this._handleAddRow = this._handleAddRow.bind(this);
    }


    _handleAddRow(){
        let row = { key : getRandomKey(), controls:[] }
        for(let ctrl of this.props.metadata){
            let control = { id: `${ctrl.id}_copy_${row.key}`, name: ctrl.id };
            row.controls.push(control);
        }
        
        this.props.onAdd(row);
    }

    render(){
        const { api, dispatcher, metadata } = this.props;
        const isCopyRow =(controls : Array<IControlSchema>) =>{
            let count = 0;
            for(let ctrl of controls){
                if(ctrl.type.toLocaleUpperCase() !== 'FILE'){
                    count++;
                }
            }
    
            return count > 0;
        }
        return (
            <div>
                {this.props.rows.map((obj: any, idx: number) => 
                        <PanelCloneRow key={obj.key} id={obj.key} 
                                controls={obj.controls}
                                onRemove={this.props.onRemove}
                                metadata={metadata} 
                                errors={this.props.errors}
                                isError={ !isUndefined(obj.isError) && obj.isError }
                                api={api} 
                                values={this.props.values} 
                                allVisited={this.props.allVisited}
                                visited={this.props.visited}
                                dispatcher={dispatcher}>
                        </PanelCloneRow> )}
                <Button bsStyle="primary" disabled={this.props.disabled} onClick={this._handleAddRow} >Добавить новый блок</Button>
                {
                    (isCopyRow(this.props.metadata)) && (
                        <Button bsStyle="success" disabled={this.props.disabled} onClick={this.props.onCopy}>Добавить блок (без документов)</Button>
                    )
                }
            </div>
        )  
    }
}

export default PanelClone;


// WEBPACK FOOTER //
// ./src/components/controls/extensions/PanelClone.tsx